export const getAiBorderMode = _ref => {
  let {
    isAnalyzing,
    isDeciding,
    isRecommendedCard,
    fadesUnpickedCards
  } = _ref;
  if (isDeciding) {
    if (isRecommendedCard) {
      return 'grow';
    }
    return fadesUnpickedCards ? 'fade' : 'off';
  }
  return isAnalyzing ? 'travel' : 'off';
};
//# sourceMappingURL=getAiBorderMode.js.map